import { createSelector } from '@reduxjs/toolkit';

import { ProfileClass } from '../../library/profiles/ProfileClass';
import { RootState } from '..';
import { SnappingLevel } from '../slices/applicationSlice';
import { getInsertingObjectInfo } from './insertionObjectSelectors';
import { getInsertingProfileClassOrNull, getTopChordWidthDuringProfileInsertion } from './profileSelectors';

export interface MousyProfileInsertionInformation {
  readonly profile: ProfileClass;
  readonly topChordWidth: number;
  readonly snappingLevel: SnappingLevel;
}

export const getMousyProfileInsertionInformation = createSelector(
  [
    getInsertingObjectInfo,
    getInsertingProfileClassOrNull,
    getTopChordWidthDuringProfileInsertion,
    (state: RootState) => state.application.snappingLevel,
  ],
  (insertingObjectInfo, profileClassResult, topChordWidth, snappingLevel): MousyProfileInsertionInformation | null => {
    if (
      insertingObjectInfo?.type !== 'componentDesign' ||
      profileClassResult == null ||
      profileClassResult.type === 'Err'
    ) {
      return null;
    }

    const profile = profileClassResult.ok;
    if (profile.isClosed) {
      return null;
    }

    return { profile, topChordWidth, snappingLevel };
  },
);

export const isMousyProfileInsertionActive = createSelector(
  [getMousyProfileInsertionInformation],
  (information) => information !== null,
);
